export default __webpack_public_path__ + "static/media/prod-varient-black.a3f04adb.jpg";